import { ISbStoryData } from "storyblok-js-client"
import { ArticlePageStoryblok, FactAdvicePageStoryblok, StoryblokComponentBase } from "./component-types"

export const isArticlePage = (
  storyContent: ISbStoryData["content"] | ArticlePageStoryblok
): storyContent is ArticlePageStoryblok => {
  return storyContent?.component === "article_page"
}

export const isFactAdvicePage = (
  storyContent: ISbStoryData["content"] | FactAdvicePageStoryblok
): storyContent is FactAdvicePageStoryblok => {
  return storyContent?.component === "fact_advice_page"
}

export const isPageWithAuthorsRef = (storyContent: ISbStoryData["content"] | ArticlePageStoryblok) => {
  return isArticlePage(storyContent) || isFactAdvicePage(storyContent)
}

export const isStoryblockComponent = <T = unknown>(
  component: StoryblokComponentBase | T
): component is StoryblokComponentBase => {
  return (
    typeof component === "object" &&
    component !== null &&
    typeof (component as StoryblokComponentBase)._uid === "string" &&
    typeof (component as StoryblokComponentBase).component === "string"
  )
}
